import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Global from '../../../../store/global-selectors';
import { ShippingStrategyDefaultTagWithName } from '../../../../components/shipping-strategy-default-tag/shipping-strategy-default-tag-with-name';
import useServiceColumnDisplay from './use-service-column-display';
import messages from '../messages';

const DomesticServiceColumn = ({ id: presetGroupId }) => {
  const serviceId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'serviceId',
    }),
  );
  const domesticRateShopperGuid = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'domesticRateShopperGuid',
    }),
  );

  const { name, isTemplate } = useServiceColumnDisplay(serviceId, domesticRateShopperGuid);

  if (!name) {
    return '';
  }

  return isTemplate ? <ShippingStrategyDefaultTagWithName name={name} /> : name;
};

DomesticServiceColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.domesticServiceColumn,
  name: <FormattedMessage {...messages.domesticServiceColumn} />,
  id: 'domesticService',
  isSortable: false,
  render: DomesticServiceColumn,
};
